module.exports = __webpack_public_path__ + "static/media/cursosError.c57df317.svg";